'use client'

import { FC } from 'react'
import { CTASection } from '../_components/granditude'

export const LandingCTASection: FC = () => {
  return (
    <CTASection
      title="Want to know what's possible?"
      description="Tell us what's broken and we'll figure out together if there's a fit. No commitment, no sales pitch."
      primaryButtonText="Let's figure it out together"
      primaryButtonHref="/signup"
      secondaryButtonText="Learn how we work"
      secondaryButtonHref="/working-together"
      variant="teal"
    />
  )
}
